import {Component, forwardRef, Input} from '@angular/core';
import {ChannelPanelComponent} from '@obj-editors/PONotificationChannelSettings/channel-panels/channel-panel';
import {UntypedFormControl, NG_VALUE_ACCESSOR} from '@angular/forms';

@Component({
  selector: 'app-telegram-channel-panel',
  templateUrl: 'telegram-channel-panel.component.html',
  styleUrls: ['./telegram-channel-panel.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => TelegramChannelPanelComponent),
      multi: true,
    },
  ],
})
export class TelegramChannelPanelComponent extends ChannelPanelComponent {
  get telegramApiKeyControl() {
    return this.formGroup.controls.apiKey as UntypedFormControl;
  }

  constructor() {
    super();
  }
}
